/*
 *   Copyright (c) 2021
 *   All rights reserved.
 */
import styled, { ITheme } from 'styled-components';

export const HeaderFrame = styled.div`
    display: block;
    background: transparent;
    padding: 0 30px;
    min-height: 81px;
    position: fixed;
    top: 55px;
    transform: translate3d(0, 0, 0);
    transition: mdc-animation-exit-temporary(transform, 350ms);
    transition-duration: 200ms;
    will-change: transform;
    z-index: 100;
    width: 100%;

    .menu-mobile .btn-primary {
        color: ${({ theme }: { theme: ITheme }) => theme.text2};
    }

    ${({ theme }: { theme: ITheme }) => theme.mediaWidth.upToMedium`
        min-height: 40px;
        padding: 0 12px;
        background: #1B1B1F !important;
        .ant-btn-round.ant-btn-lg {
            padding: 0;
        }
        .menu-mobile {
            min-height: 40px;
            display: flex !important;
            align-items: center;
            justify-content: space-between;
            .mode-dark-light {
                opacity: 0;
                width: 70px;
            }
            .logo {
                height: 20px;
                svg {
                    height: 20px;
                }
            }
            .connect-mobile {
                min-height: 40px;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                .btn-network {
                    width: fit-content !important;
                    padding-left: 10px;
                    padding-right: 10px;
                    height: 40px;
                    margin-right: 12px;
                    background: transparent !important;
                    border: 2px solid ${theme.dark3};
                }

                .btn-menu-mobile {
                    background: none;
                    border: none;
                    height: 40px;
                    width: 70px;
                    // margin-left: 8px;

                    &:hover {
                        background: none !important;
                        border: none !important; 
                    }
                }
            }
        }
        .menu-desktop {
            display: none !important;
        }
    `}
    .menu-mobile {
        display: none;
    }
    .menu-desktop {
        height: 100%;
        min-height: 81px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .logo {
            margin-left: -67px;
        }
        .drawer-menu {
            span {
                margin-left: 4px;
                color: ${({ theme }: { theme: ITheme }) => theme.text1};
            }
        }
        .right-header {
            position: relative;
            .position-right-header {
                position: absolute;
                right: 0;
                top: -20px;
            }
            .network {
                flex: 1;
                display: flex;
                justify-content: flex-end;
                min-width: 440px;
                .btn-account {
                    font-size: 20px;
                    font-weight: 600;
                    text-transform: uppercase;
                    width: 40px !important;
                    border-radius: 28px;
                    height: 40px;
                    padding-left: 10px;
                    padding-right: 10px;
                    margin-right: 12px;
                    background: ${({ theme }: { theme: ITheme }) => theme.green1};
                    border: 1px solid ${({ theme }: { theme: ITheme }) => theme.border1};
                }
                .btn-network {
                    width: 120px;
                    color: ${({ theme }: { theme: ITheme }) => theme.text2};
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding-left: 10px;
                    padding-right: 10px;
                    height: 40px;
                    margin-right: 12px;
                    background: transparent !important;
                    border: 2px solid ${({ theme }: { theme: ITheme }) => theme.dark3};
                }
                .btn-network ~ .ant-btn {
                    margin-left: 12px;
                }
                .btn-login {
                    max-width: 100px;
                    width: 100%;
                    margin-right: 12px;
                }
                .btn-gradient {
                    background: -webkit-linear-gradient(-75deg, #15b2f4 0%, #9546c2 50%, #fd7942 75%);
                    border: none;
                }
                .btn-round {
                    background: none;
                    border: 2px solid ${({ theme }: { theme: ITheme }) => theme.dark3};
                    width: 60px !important;
                    height: 40px;
                    margin-left: 8px;
                }
            }
        }
    }
`;
